import { whatsappConversationSharedLocalizations } from '../shared/whatsappConversationLocalizations';
import { whatsappConversationModalContent } from '../shared/whatsappConversationModalContent';

export const localization = {
  pt: {
    locale: 'pt-BR',
    header: 'Relatório de consumo: Conversas via WhatsApp',
    monthPlaceholder: 'Período',
    conversationTypeLabel: 'Conversas',
    conversationWabaLabel: 'WABA',
    title: 'Mensagens via WhatsApp',
    plan: 'Plano {0}: Mensagens',
    middleInfo: '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
    endInfo:
      'Os valores deste relatório são recebidos direto do WhatsApp e podem ser diferentes dos mostrados na fatura. Use o relatório apenas como estimativa do seu consumo.',
    learnMore: 'Saiba mais sobre os termos',
    modalContent: {
      title: 'Detalhamento dos termos de consumo',
      delivered: whatsappConversationModalContent.pt.delivered,
      paids: whatsappConversationModalContent.pt.paids,
      free: whatsappConversationModalContent.pt.free,
      entryPoint: whatsappConversationModalContent.pt.entryPoint,
      service: whatsappConversationModalContent.pt.service,
      action: 'Fechar',
    },
    showMoreButton: 'Mostrar mais',
    consolidated: {
      tooltip: {
        allConversations: whatsappConversationSharedLocalizations.pt.conversationTooltips.allConversations,
        billedConversations: whatsappConversationSharedLocalizations.pt.conversationTooltips.billedConversations,
        freeOfChargeConversations: 'As mensagens entregues são consideradas gratuitas quando se enquadram na janela de atendimento ao cliente de 24 horas ou na janela de ponto de entrada gratuito de 72 horas.',
      },
      sessionsByUser: 'Conversas iniciadas pelo usuário',
      sessionsByCompany: 'Conversas iniciadas pela empresa',
      sessionsTotal: 'Total de conversas',
      conversationTypeCategory: {
        newPricing: {
          subTitle: 'Dados depois da alteração de categorias',
          marketing: 'Marketing',
          marketing_lite: 'Marketing Lite',
          utility: 'Utilidade',
          authentication: 'Autenticação',
          service: 'Serviço',
          all: {
            title: 'Mensagens entregues',
            title_detail: 'Detalhamento mensagens entregues',
          },
          regular: {
            title: 'Mensagens pagas entregues',
            title_detail: 'Detalhamento das mensagens pagas entregues',
          },
          free: {
            title: 'Mensagens gratuitas entregues',
            title_detail: 'Detalhamento das mensagens gratuitas entregues',
            freeTier: 'Free Tier',
            freeEntryPoint: 'Ponto de entrada gratuito',
            freeCustomerService: 'Atendimento ao cliente grátis',
          },
        },
        oldPricing: {
          title: 'Dados antes da alteração de categorias',
          sessionsByUser: 'Conversas iniciadas pelo usuário',
          sessionsByCompany: 'Conversas iniciadas pela empresa',
        },
      },
    },
    defaultConversationTypeValue: 'All',
    conversationType: [
      { value: 'All', label: 'Todas as conversas' },
      { value: 'FreeTier', label: 'Conversas grátis' },
      { value: 'Regular', label: 'Conversas cobradas' },
    ],
    chatbotSessionConsumption: {
      title: 'Números de telefone',
      about: 'Acompanhe o consumo de mensagens.',
      columnPhoneNumber: 'Telefone',
      columnUserSession: 'Conversa iniciada pelo usuário',
      columnEnterpriseSession: 'Conversa iniciada pela empresa',
      columnTotal: 'Total',
      buttonAllChatbots: 'Ver mais',
    },

    sessionDailyConsumption: {
      title: 'Contagem diária de mensagens',
      about: 'Acompanhe o consumo diário de mensagens.',
      columnDateReference: 'Data',
      columnUserSession: 'Conversa iniciada pelo usuário',
      columnBusinessSession: 'Conversa iniciada pela empresa',
      columnTotal: 'Total',
      buttonAllChatbots: 'Ver mais',
    },

    sessionConsumptionByPhone: {
      title: 'Números de telefone',
      about: 'Acompanhe o consumo de mensagens.',
      columnPhoneNumber: 'Telefone',
      businessInitiated: {
        bannerText:
          'Importante! Mensagens iniciadas pela empresa agora são classificadas pela Meta em 4 tipos: Utilidade, Autenticação, Marketing ou Marketing Lite.',
        bannerLinkText: 'Mais Informações',
        tab: 'Mensagens pagas',
        columnUtility: 'Utilidade',
        columnAuthentication: 'Autenticação',
        columnMarketing: 'Marketing',
        columnMarketingLite: 'Marketing Lite',
        columnService: 'Serviço',
      },
      userInitiated: {
        bannerLinkText: 'Mais Informações',
        tab: 'Mensagens gratuitas',
        service: 'Serviços',
        free: 'Gratuitas',
      },
      columnTotal: 'Total',
    },

    sessionConsumptionByDate: {
      title: 'Números de telefone',
      about: 'Acompanhe o consumo de mensagens.',
      columnDateReference: 'Data',
      businessInitiated: {
        bannerText:
          'Importante! Mensagens iniciadas pela empresa agora são classificadas pela Meta em 3 tipos: Utilidade, Autenticação ou Marketing.',
        bannerLinkText: 'Mais Informações',
        tab: 'Mensagens pagas',
        columnUtility: 'Utilidade',
        columnAuthentication: 'Autenticação',
        columnMarketing: 'Marketing',
        columnMarketingLite: 'Marketing Lite',
        columnService: 'Serviço',
      },
      userInitiated: {
        bannerText:
          'Importante! As conversas iniciadas pelo usuário são classificadas pela Meta como conversas de Serviço.',
        bannerLinkText: 'Mais Informações',
        tab: 'Mensagens gratuitas',
        service: 'Serviços',
        free: 'Gratuitas',
      },
      columnTotal: 'Total',
    },
  },
  en: {
    locale: 'en-US',
    header: 'Usage report: Conversations via WhatsApp',
    monthPlaceholder: 'Period',
    conversationTypeLabel: 'Conversation',
    conversationWabaLabel: 'WABA',
    title: 'Messages via WhatsApp',
    plan: '{0}: Messages',
    middleInfo: '*Monthly statements will become available within 5 business days of month end.',
    endInfo:
      'The numbers in this report come directly from WhatsApp and may differ from the numbers shown on the invoice. It is best to use the report only as an estimate of your consumption.',
    learnMore: 'Learn more about the terms',
    modalContent: {
      title: 'Detailed explanation of terms',
      delivered: whatsappConversationModalContent.en.delivered,
      paids: whatsappConversationModalContent.en.paids,
      free: whatsappConversationModalContent.en.free,
      entryPoint: whatsappConversationModalContent.en.entryPoint,
      service: whatsappConversationModalContent.en.service,
      action: 'Close',
    },
    consolidated: {
      tooltip: {
        allConversations: whatsappConversationSharedLocalizations.en.conversationTooltips.allConversations,
        billedConversations: whatsappConversationSharedLocalizations.en.conversationTooltips.billedConversations,
        freeOfChargeConversations:
          'Messages delivered are considered free of charge when they fall within the 24-hour customer service window or the 72-hour free entry point window.',
      },
      sessionsByUser: 'User-initiated conversations',
      sessionsByCompany: 'Company-initiated conversations',
      sessionsTotal: 'Total of conversations',
      conversationTypeCategory: {
        newPricing: {
          subTitle: 'Data after category changes',
          marketing: 'Marketing',
          marketing_lite: 'Marketing Lite',
          utility: 'Utility',
          authentication: 'Authentication',
          service: 'Service',
          all: {
            title: 'Messages delivered',
            title_detail: 'Details of delivered messages',
          },
          regular: {
            title: 'Paid messages delivered',
            title_detail: 'Details of paid messages delivered',
          },
          free: {
            title: 'Free messages delivered',
            title_detail: 'Details of free messages delivered',
            freeTier: 'Free Tier',
            freeEntryPoint: 'Free entry points',
            freeCustomerService: 'Free customer service',
          },
        },
        oldPricing: {
          title: 'Data before category changes',
          sessionsByUser: 'User-initiated',
          sessionsByCompany: 'Company-initiated',
          total: 'Total of conversations',
        },
      },
    },
    defaultConversationTypeValue: 'All',
    conversationType: [
      { value: 'All', label: 'See all conversations' },
      { value: 'FreeTier', label: 'Free-of-charge conversations' },
      { value: 'Regular', label: 'Billed conversations' },
    ],
    chatbotSessionConsumption: {
      title: 'Phone number',
      about: 'Track your messaging usage.',
      columnPhoneNumber: 'Phone number',
      columnUserSession: 'User-initiated conversation',
      columnEnterpriseSession: 'Company-initiated conversation',
      columnTotal: 'Total',
      buttonAllChatbots: 'See more',
    },
    sessionDailyConsumption: {
      title: 'Daily message count',
      about: 'Track your daily message usage.',
      columnDateReference: 'Date',
      columnUserSession: 'User-initiated conversation',
      columnBusinessSession: 'Company-initiated conversation',
      columnTotal: 'Total',
      buttonAllChatbots: 'See more',
    },
    sessionConsumptionByPhone: {
      title: 'Phone number',
      about: 'Track your messaging usage.',
      columnPhoneNumber: 'Phone number',
      businessInitiated: {
        bannerText:
          'Important! Company-initiated messages are now classified by Meta into four types: Utility, Authentication, Marketing or Marketing Lite.',
        bannerLinkText: 'More Information',
        tab: 'Paid messages',
        columnUtility: 'Utility',
        columnAuthentication: 'Authentication',
        columnMarketing: 'Marketing',
        columnMarketingLite: 'Marketing Lite',
        columnService: 'Service',
      },
      userInitiated: {
        bannerLinkText: 'More Information',
        tab: 'Free messages',
        service: 'Service',
        free: 'Free',
      },
      columnTotal: 'Total',
    },

    sessionConsumptionByDate: {
      title: 'Daily conversation count',
      about: 'Track your messaging usage.',
      columnDateReference: 'Date',
      businessInitiated: {
        bannerText:
          'Important! Company-initiated messages are now classified by Meta into four types: Utility, Authentication, Marketing or Marketing Lite.',
        bannerLinkText: 'More Information',
        tab: 'Paid messages',
        columnUtility: 'Utility',
        columnAuthentication: 'Authentication',
        columnMarketing: 'Marketing',
        columnMarketingLite: 'Marketing Lite',
        columnService: 'Service',
      },
      userInitiated: {
        bannerText: 'Important! User-initiated conversations are classified by Meta as Service.',
        bannerLinkText: 'More Information',
        tab: 'Free messages',
        service: 'Service',
        free: 'Free',
      },
      columnTotal: 'Total',
    },
  },
  es: {
    locale: 'es-ES',
    header: 'Reporte de consumo: Conversaciones vía WhatsApp',
    monthPlaceholder: 'Período',
    conversationTypeLabel: 'Conversaciones',
    conversationWabaLabel: 'WABA',
    title: 'Mensajes por WhatsApp',
    plan: 'Plano {0}: Mensajes',
    middleInfo:
      '*El cierre de un mes estará disponible dentro de los 5 días hábiles a partir del último día de ese mes.',
    endInfo:
      'Los importes de este informe se reciben directamente de WhatsApp y pueden diferir de los que se muestran en la factura. Utilice este informe solo como una estimación de su consumo.',
    learnMore: 'Explicación detallada de los términos',
    modalContent: {
      title: 'Explicación detallada de los términos',
      delivered: whatsappConversationModalContent.es.delivered,
      paids: whatsappConversationModalContent.es.paids,
      free: whatsappConversationModalContent.es.free,
      entryPoint: whatsappConversationModalContent.es.entryPoint,
      service: whatsappConversationModalContent.es.service,
      action: 'Cerrar',
    },
    consolidated: {
      tooltip: {
        allConversations: whatsappConversationSharedLocalizations.es.conversationTooltips.allConversations,
        billedConversations: whatsappConversationSharedLocalizations.es.conversationTooltips.billedConversations,
        freeOfChargeConversations:
          'Los mensajes entregados se consideran gratuitos cuando se encuentran dentro del plazo de atención al cliente de 24 horas o del plazo de entrada gratuita de 72 horas.',
      },
      sessionsByUser: 'Conversaciones iniciadas por el usuario',
      sessionsByCompany: 'Conversaciones iniciadas por la empresa',
      sessionsTotal: 'Total de conversaciones',
      conversationTypeCategory: {
        newPricing: {
          subTitle: 'Datos después de cambiar de categoría',
          marketing: 'Marketing',
          marketing_lite: 'Marketing Ligero',
          utility: 'Utilidad',
          authentication: 'Autenticación',
          service: 'Servicio',
          all: {
            title: 'Mensajes entregados',
            title_detail: 'Detalles de los mensajes enviados',
          },
          regular: {
            title: 'Mensajes pagados entregados',
            title_detail: 'Detalles de los mensajes pagados entregados',
          },
          free: {
            title: 'Mensajes gratuitos entregados',
            title_detail: 'Detalles de los mensajes gratuitos entregados',
            freeTier: 'Free Tier',
            freeEntryPoint: 'Punto de entrada gratuito',
            freeCustomerService: 'Atención al cliente gratis',
          },
        },
        oldPricing: {
          title: 'Datos antes de cambiar de categoría',
          sessionsByUser: 'Iniciadas por el usuario',
          sessionsByCompany: 'Iniciadas por la empresa',
          total: 'Total de conversaciones',
        },
      },
    },
    defaultConversationTypeValue: 'All',
    conversationType: [
      { value: 'All', label: 'Todas las conversaciones' },
      { value: 'FreeTier', label: 'Conversaciones gratis' },
      { value: 'Regular', label: 'Conversaciones cobradas' },
    ],
    chatbotSessionConsumption: {
      title: 'Número de teléfono',
      about: 'Sigue el uso de tus mensajes.',
      columnPhoneNumber: 'Número de teléfono',
      columnUserSession: 'Conversación iniciada por el usuario',
      columnEnterpriseSession: 'Conversación iniciada por la empresa',
      columnTotal: 'Total',
      buttonAllChatbots: 'Ver más',
    },
    sessionDailyConsumption: {
      title: 'Conteo diario de mensajes',
      about: 'Sigue el uso diario de tus mensajes.',
      columnDateReference: 'Fecha',
      columnUserSession: 'Conversación iniciada por el usuario',
      columnBusinessSession: 'Conversación iniciada por la empresa',
      columnTotal: 'Total',
      buttonAllChatbots: 'Ver más',
    },
    sessionConsumptionByPhone: {
      title: 'Número de teléfono',
      about: 'Sigue el uso de tus mensajes.',
      columnPhoneNumber: 'Número de teléfono',
      businessInitiated: {
        bannerText:
          '¡Importante! Los mensajes iniciados por la empresa ahora están clasificados por Meta en cuatro tipos: Utilidad, Autenticación, Marketing o Marketing Lite.', bannerLinkText: 'Mas informaciones',
        tab: 'Mensajes pagados',
        columnUtility: 'Utilidad',
        columnAuthentication: 'Autenticación',
        columnMarketing: 'Marketing',
        columnMarketingLite: 'Marketing Ligero',
        columnService: 'Servicio',
      },
      userInitiated: {
        bannerLinkText: 'Mas informaciones',
        tab: 'Mensajes gratuitos',
        service: 'Servicio',
        free: 'Gratuitas',
      },
      columnTotal: 'Total',
    },

    sessionConsumptionByDate: {
      title: 'Daily conversation count',
      about: 'Sigue el uso de tus mensajes.',
      columnDateReference: 'Date',
      businessInitiated: {
        bannerText:
          '¡Importante! Los mensajes iniciados por la empresa ahora están clasificados por Meta en cuatro tipos: Utilidad, Autenticación, Marketing o Marketing Lite.', 
        bannerLinkText: 'Mas informaciones',
        tab: 'Mensajes pagados',
        columnUtility: 'Utilidad',
        columnAuthentication: 'Autenticación',
        columnMarketing: 'Marketing',
        columnMarketingLite: 'Marketing Ligero',
        columnService: 'Servicio',
      },
      userInitiated: {
        bannerText:
          '¡Importante! Las conversaciones iniciadas por el usuario se clasifican por Meta como conversaciones de Servicio.',
        bannerLinkText: 'Mas informaciones',
        tab: 'Mensajes gratuitos',
        service: 'Servicio',
        free: 'Gratuitas',
      },
      columnTotal: 'Total',
    },
  },
};
